import { ApiType } from "@gymflow/common";
import { utcToZonedTime, zonedTimeToUtc } from "@gymflow/helpers";
import {
  ApiListResponse,
  MembershipPausingDTO,
  MembershipType,
} from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";

import { defaultPage } from "../defaultPage";
import { reportQueryKeys } from "./reportQueryKeys";

export function useMembershipPausingReport({
  api,
  startDate,
  endDate,
  membershipIncluded,
  membershipExcluded,
  membershipType,
  page,
  limit,
  sort,
  tz,
}: {
  api: ApiType;
  startDate?: string;
  endDate?: string;
  membershipIncluded?: number[];
  membershipExcluded?: number[];
  membershipType?: MembershipType;
  page?: number;
  limit?: number;
  sort?: any;
  tz: string;
}) {
  const result = useQuery({
    queryKey: reportQueryKeys.membershipPausing({
      startDate,
      endDate,
      membershipIncluded,
      membershipExcluded,
      membershipType,
      page,
      limit,
      sort,
    }),
    queryFn: async () => {
      const utcStart = zonedTimeToUtc(startDate as string, tz);
      const utcEnd = zonedTimeToUtc(endDate as string, tz);
      const result = await api.memberApi.membershipPausing({
        dateFrom: utcStart,
        dateTo: utcEnd,
        membershipIncluded,
        membershipExcluded,
        membershipType,
        page,
        limit,
        sort,
      });
      return result.data as ApiListResponse<MembershipPausingDTO>;
    },
    placeholderData: defaultPage<MembershipPausingDTO>,
    select: (data: ApiListResponse<MembershipPausingDTO>) => {
      return {
        ...data,
        content: data.content.map(({ pauseDate, resumeDate, ...rest }) => {
          return {
            pauseDate: pauseDate && utcToZonedTime(pauseDate, tz),
            resumeDate: resumeDate && utcToZonedTime(resumeDate, tz),
            ...rest,
          };
        }),
      } as ApiListResponse<MembershipPausingDTO>;
    },
    enabled: !!startDate && !!endDate && !!tz,
  });
  return result;
}
